import React, {useState,useEffect} from "react";
import {useLocation, useParams} from "react-router-dom";
import axios from "axios";
import {useAuthDispatch} from "../../Context/auth-context";
import {useMediaQuery} from "beautiful-react-hooks";
import { Link} from "react-router-dom";
import ReactRecaptcha3 from 'react-google-recaptcha3';
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import SlideSHowLogin from "./SlideShowLogin";
const BASEURL = 'https://api.sinatether.com/Auth/login/'

  

const fetchToken = async (Phone,token,source)=>{
        return axios.post(BASEURL,{'phone':Phone,"token":token,'source':source},
            {withCredentials:true})
    }


export default function Rlogin(){
    const navigate =  useNavigate()
    const  YOUR_SITE_KEY = '6LcQ-54gAAAAAMvAhDj5nKog3L882SfR9WxFtv99'

    const dispatch = useAuthDispatch()

    const [Phone,setPhone] = useState("")
    const [error,seterror] = useState('')
    const [isLoading,setIsLoading] = useState(false)
    const isSmall = useMediaQuery('(max-width: 768px)')



    var canonical = document.querySelector('link[rel="canonical"]');
    if (canonical !== null) {
    canonical.href = `https://sinatether.com/login`;
    }

    let query = useQuery()
    try{
        var source = localStorage.getItem('source')
        var ref = localStorage.getItem('ref')

        if (!source){
         source = query.get("utm_source")
        localStorage.setItem("source",source)
       }
       if(!ref){
         ref =  query.get("ref")
         localStorage.setItem("ref",ref)


       }
    }
    catch{
        var source = ''
        
    }








     
    function useQuery() {
        const { search } = useLocation();

        return React.useMemo(() => new URLSearchParams(search), [search]);
        }



        useEffect(() => {
            ReactRecaptcha3.init(YOUR_SITE_KEY).then(
              (status) => {
              }
            );
          }, [])




   function HandelClick(event) {
    event.preventDefault()




        setIsLoading(true)

       ReactRecaptcha3.getToken().then(
        (resp) => {
          console.log(resp);
  
         fetchToken(Phone,resp,source).then(
             (res) => {
                 console.log(res)
                 if (res.data['status'] == 200) {

                             navigate('/verify', {state:{phone:Phone},replace:true})
  
  
                 }else {
                     toast.warning(res.data['message'])
                     setIsLoading(false)
  
                 }
             }
  
  
         )
        },
        (error) => {
                    setIsLoading(false)
                    fetchToken(Phone,'').then(
                        (res) => {
                            console.log(res)
                            if (res.data['status'] == 200) {
                                navigate('/verify',{state:{phone:Phone},replace:true})
             
             
                            }else {
                                toast.warning(res.data['message'])
                                setIsLoading(false)
             
                            }
                        }
             
             
                    )
                   //toast.error("فرایند به طور کامل انجام نشد مجددا تلاش فرمایید")
  
  
        }
      );
       

   }

  
   function toEnglishNumber(strNum) {
    var pn = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
    var en = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
    var an = ["٠", "١", "٢", "٣", "٤", "٥", "٦", "٧", "٨", "٩"];
    var cache = strNum;
    for (var i = 0; i < 10; i++) {
        var regex_fa = new RegExp(pn[i], 'g');
        var regex_ar = new RegExp(an[i], 'g');
        cache = cache.replace(regex_fa, en[i]);
        cache = cache.replace(regex_ar, en[i]);
    }
    return cache;
}

   function handelCheck(event){
        var pattern = new RegExp(/^09[0-9]{9}/);
        var pattern1 =  new RegExp(/^@#@_[0-9]{2}/)
        let p = event.target.value
        if (pattern1.test(p)){
            if (p.length == 6){
                seterror('')
                setPhone(p)
                return
            }
        }




        p = toEnglishNumber(p)




       /*if(p.length==11)
       {*/
           if (!pattern.test(p))
            {
            seterror('لطفا شماره تلفن خود را درست وارد نمایید')
            }else if(p.length==11) {
               seterror('')
               setPhone(p)
           }
           else {
                           seterror('لطفا شماره تلفن خود را درست وارد نمایید')
           }
      /* }
       else {
           seterror('شماره تلفن وارد شده صحیح نیست!')
       }*/


   }




   
   







    return(

        <SlideSHowLogin>


       <>


        





           {isSmall ?
               <>

                          {/* <div id="preloader">
                                   <div className="sk-three-bounce">
                                       <div className="sk-child sk-bounce1">

                                       </div>
                                       <div className="sk-child sk-bounce2">

                                       </div>
                                       <div className="sk-child sk-bounce3">

                                       </div>
                                   </div>
                    </div> */}



                    

<div className="card-size">
                   <div className="container h-100">
                       <div className="row justify-content-center h-100 align-items-center">
                           <div className="">
                               <div className="mini-logo text-center my-2">
                               </div>
                               <div className="auth-form card custom-shadow">
                                   <div className="card-body">
                                       <div className="row text-center pb-4">
                                       <Link to={'/'}>

                                       <img className={'logo-desk-css2 dksdlogosmall'} src={'./images/mob-logo.svg'} alt={'سینا تتر'}/>

                                       </Link>

 


                                       </div>
                                       <h5 className="text-center   ">ورود | ثبت نام</h5>
                                       <hr/>

      

                                       <form onSubmit={HandelClick} className={'mt-4'}>
                                           <div className="form-group mt-3 ">
                                               <span className={'h6 text-large  mb-2'}>شماره تلفن خود را وارد نمایید</span>
                                               <div className="input-group mb-3 text-center">
                                                   <input type="tel" className="form-control text-center myinput_form h-100  mt-2 " placeholder="09---" id={"name"} name={'phone'} onChange={handelCheck}  required />

                                               </div>
                                               <div className={'text-danger h6 text-large'}>
                                                   {error}
                                               </div>
                                           </div>
                                           <div className="text-center mt-4">
                                               <button disabled={error} type="submit" className="btn btn-primary btn-block spinner-button py-2 new-btn" id="load" data-loading-text="<i class='fas fa-spinner fa-pulse'></i>" >
                                                   {isLoading ?
                                                               <div>
                                                               <i className="fa fa-spinner fa-spin text-white"></i>

                                                               </div>
                                                               :
                                                               <span>ارسال</span>
                                                           }

                                               </button>
                                     <Link to={'/'}>
                                                           <button type={'button'} className={'btn text-medium btn-outline-primary mt-5 py-2 px-1 btn-font new-btn-out'}>
                                                   بازگشت به صفحه اصلی
                                                           </button>
                                                       </Link>

                                           </div>






                                       </form>



                                   </div>
                               </div>
                           </div>
                       </div>
                   </div>
               </div>



             </>


               :
               <>


                        {/* <div id="preloader">
                                   <div className="sk-three-bounce">
                                       <div className="sk-child sk-bounce1">

                                       </div>
                                       <div className="sk-child sk-bounce2">

                                       </div>
                                       <div className="sk-child sk-bounce3">

                                       </div>
                                   </div>
                    </div> */}



                          <div className="card-size">
                   <div className="container h-100">
                       <div className="row justify-content-center h-100 align-items-center">
                           <div className="">
                               <div className="mini-logo text-center my-2">
                               </div>
                               <div className="auth-form card custom-shadow">
                                   <div className="card-body">
                                       <div className="row text-center pb-4">
                                       <Link to={'/'}>

                                       <img className={'logo-desk-css2'} src={'./images/mob-logo.svg'} alt={'سینا تتر'}/>
                                       </Link>

 


                                       </div>
                                       <h5 className="text-center   ">ورود | ثبت نام</h5>
                                       <hr/>

      

                                       <form onSubmit={HandelClick} className={'mt-4'}>
                                           <div className="form-group mt-3 ">
                                               <span className={'h6 text-large  mb-2'}>شماره تلفن خود را وارد نمایید</span>
                                               <div className="input-group mb-3 text-center">
                                                   <input type="tel" className="form-control text-center myinput_form h-100  mt-2 " placeholder="09---" id={"name"} name={'phone'} onChange={handelCheck}  required />

                                               </div>
                                               <div className={'text-danger h6 text-large'}>
                                                   {error}
                                               </div>
                                           </div>
                                           <div className="text-center mt-4">
                                               <button disabled={error} type="submit" className="btn btn-primary btn-block spinner-button py-2 new-btn" id="load" data-loading-text="<i class='fas fa-spinner fa-pulse'></i>" >
                                                   {isLoading ?
                                                               <div>
                                                               <i className="fa fa-spinner fa-spin text-white"></i>

                                                               </div>
                                                               :
                                                               <span>ارسال</span>
                                                           }

                                               </button>
                                     <Link to={'/'}>
                                                           <button type={'button'} className={'btn text-medium btn-outline-primary mt-5 py-2 px-1 btn-font new-btn-out'}>
                                                   بازگشت به صفحه اصلی
                                                           </button>
                                                       </Link>

                                           </div>






                                       </form>



                                   </div>
                               </div>
                           </div>
                       </div>
                   </div>
               </div>


                   </>



           }




       </>


       </SlideSHowLogin>




    )
}